<template>
  <div class="tab-pane_wrapper">
    <div class="top-bar" style="justify-content: flex-end; margin: 10px 0;">
      <el-button
          size="small"
          plain type="primary"
          icon="mdi mdi-plus"
          @click="discountCreateAction"
      >
        Add new
      </el-button>
    </div>

    <el-table :data="discounts" style="width: 100%; min-width:500px;">
      <el-table-column prop="name" label="Name" sortable />

      <el-table-column width="150px" prop="code" label="StripeID" sortable />

      <el-table-column width="150px" prop="percent_off" label="Percent off" />

      <el-table-column width="150px" prop="duration" label="Duration" />

      <el-table-column width="185px" align="right" label="Actions">
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="primary"
              icon="mdi mdi-pencil"
              plain
              @click="discountEditHandler(scope.row.id)"
          >
            Edit
          </el-button>

          <el-button
              size="mini"
              type="danger"
              icon="mdi mdi-close"
              plain
              @click="deleteDiscount(scope.row)"
          >
            Delete
          </el-button>

        </template>
      </el-table-column>
    </el-table>
    <DiscountAddEditDialog
        ref="addEditDiscount"
        v-if="dialogAction"
        :modal-state="isDialogVisible"
        :discount-id="discountId"
        :dialog-action="dialogAction"
        @hide-modal="toggleDialogStateHandler"
    />
  </div>
</template>

<script>
  import {mapGetters} from "vuex"
  import DiscountAddEditDialog from './DiscountAddEditDialog'

  export default {
    name: 'DiscountsListTable',
    components: { DiscountAddEditDialog },
    data () {
      return {
        sortBy: {
          name: 0,
          code: 0,
        },
        discountId: '',
        isDialogVisible: false,
        dialogAction: ''
      }
    },
    computed: {
      ...mapGetters({
        discounts: 'discounts/getDiscounts',
        discountMeta: 'discounts/getDiscountMeta',
      }),
    },
    mounted () {
      this.$store.dispatch('discounts/getDiscounts')
    },
    methods: {
      updateDiscountList () {
        let params = 'sort='
        if (this.sortBy) {
          for (let itm in this.sortBy) {
            if (this.sortBy[itm] === 1) {
              params = `${params}${itm},`
            } else if (this.sortBy[itm] === -1) {
              params = `${params}-${itm},`
            }
          }
        }

        if (params === 'sort=') {
          params = ''
        }

        params = `${params}&page=${this.chosenPage}`
        if (this.countNets) {
          params = `${params}&per_page=${this.countNets}`
        }
        if (this.filterNets.length) {
          params = `${params}&filter=${this.filterNets}`
        }

        this.stingParam = params
        this.$store.dispatch('discounts/getDiscounts', params)
      },
      deleteDiscount (netData) {
        this.$confirm('This will permanently delete the discount. Be careful the discount can be binded to a coupon. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'error',
          center: true
        }).then(() => {
          this.$store.dispatch('discounts/deleteDiscount', netData.id)
          this.$message({
            type: 'success',
            showClose: true,
            message: 'Delete completed'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            showClose: true,
            message: 'Delete canceled'
          });
        })
      },
      handleEdit (index, row) {
        this.$router.push({name: 'discount-edit', params: {id: row.id}})
      },
      goToAddDiscount(){
        this.$router.push({name: 'discount-create'})

      },
      toggleDialogStateHandler() {
        this.dialogAction = ''
        this.isDialogVisible = false
      },
      discountEditHandler(id) {
        this.discountId = id
        this.dialogAction = 'Edit'
        this.isDialogVisible = true
      },
      discountCreateAction() {
        this.dialogAction = 'Add'
        this.isDialogVisible = true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .count-discounts {
    width: 170px;
    margin-bottom: 25px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    & > div {
      margin: 0 5px;
    }
  }
</style>
